import React from "react";
import ReactModal from "react-modal";

import { Button } from "@/design-system/components/Button/Button";
import { EditableEnvironment } from "../reducers/environments";

const modalStyles = {
  content: {
    zIndex: 10050,
    minHeight: `100px`,
    width: 600,
    top: "auto",
    bottom: "auto",
    right: "auto",
    left: "auto",
    position: "static" as "static",
    display: "flex",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, .8)",
    zIndex: 10000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
export type EnvironmentDeletionModalState = {
  environment: EditableEnvironment;
  onClose?: () => void;
  onDelete: (project: EditableEnvironment) => void;
};

export const DeleteEnvironmentModal: React.FC<
  EnvironmentDeletionModalState
> = ({ environment, onClose, onDelete }) => {
  const onConfirm = React.useCallback(() => {
    onDelete(environment);
  }, [onDelete, environment]);

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel="Delete Environment?"
    >
      <div className="flex w-full flex-col justify-between">
        <div className="mb-4 border-b pb-4">
          <h2>Delete Environment?</h2>
          <h4 className="text-md font-bold text-gray-500 uppercase">
            Environment: {environment.name}
          </h4>
        </div>

        <p className="text-xs text-gray-700">
          This action will delete this environment
        </p>

        <div className="mt-8 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </ReactModal>
  );
};
